import React from 'react';
import { Button, useNotify, useRefresh } from 'react-admin';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import IconCancel from '@material-ui/icons/Cancel';

import IntegrationModal from './IntegrationModal';
import { apiPut } from '../brainApi';

const ToggleForm = ({
  name,
  closeModal,
  isActive,
  integrationConnectionId,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const handleSubmit = async () => {
    if (isActive) {
      apiPut(`/integration-connection/${integrationConnectionId}`, {
        is_active: false,
      }).then(() => {
        notify(`Successfully deactivated ${name}`);
        refresh();
        closeModal();
      });
    } else {
      apiPut(`/integration-connection/${integrationConnectionId}`, {
        is_active: true,
      }).then(() => {
        notify(`Successfully activated ${name}`);
        refresh();
        closeModal();
      });
    }
  };
  return (
    <IntegrationModal closeModal={closeModal}>
      <DialogTitle>
        {isActive ? `Deactivate ${name}` : `Activate ${name}`}
      </DialogTitle>
      <DialogContent>
        <div>
          {isActive
            ? `Are you sure you want to deactivate your connection to ${name}?`
            : `Do you want to activate your connection to ${name}?`}
        </div>
      </DialogContent>
      <DialogActions>
        <Button label="ra.action.cancel" onClick={closeModal}>
          <IconCancel />
        </Button>
        <Button
          variant="contained"
          color={isActive ? '' : 'primary'}
          label={isActive ? 'Deactivate' : 'Activate'}
          onClick={handleSubmit}
        />
      </DialogActions>
    </IntegrationModal>
  );
};

export default ToggleForm;
